import { useAuth } from '@clerk/nextjs'

import { useEffect, useRef } from 'react'

import mediaEndpoints from '@/api/endpoints'

export default function useApi() {
  const { getToken, userId } = useAuth()
  const previousUserId = useRef(userId)

  const api = useRef(mediaEndpoints(getToken, userId))

  useEffect(() => {
    if (previousUserId.current !== userId) {
      api.current = mediaEndpoints(getToken, userId)
      previousUserId.current = userId
    }
  }, [getToken, userId])

  return api.current
}
